import { safeNum } from '../extractors/_shared';
const buildJ = (emoji, zh, en, positive) => ({ emoji, labelZh: zh, labelEn: en, positive });

/** Top1 持有者占比（0~100）*/
export function judgeTop1(pct) {
  const r = safeNum(pct);
  if (r == null) return null;
  if (r < 5)  return buildJ('🟢', '高度分散', 'Distributed', true);
  if (r < 15) return buildJ('🟢', '合理',     'Healthy',     true);
  if (r < 30) return buildJ('🟡', '偏集中',   'Concentrated', null);
  return         buildJ('🔴', '中心化风险', 'Centralized', false);
}

/** Top10 累计占比（0~100）*/
export function judgeTop10(pct) {
  const r = safeNum(pct);
  if (r == null) return null;
  if (r < 30) return buildJ('🟢', '高度分散', 'Distributed', true);
  if (r < 50) return buildJ('🟡', '中等集中', 'Moderate',    null);
  if (r < 70) return buildJ('🟠', '偏集中',   'Concentrated', false);
  return         buildJ('🔴', '极度集中', 'Heavily concentrated', false);
}
